// ViewModeToggle — 웹/모바일 화면 수동 전환 플로팅 버튼.
// useIsMobile 자동판정(폭+터치)을 사용자가 강제 override(localStorage)로 바꿀 수 있게 함.
// 어느 모드에서도 항상 접근 가능하도록 고정 위치(좌하단, 모바일 탭바 위). 로그인 화면 포함 전 페이지 노출.
import { useLocation } from 'react-router-dom';
import { IconDeviceDesktop, IconDeviceMobile } from '@tabler/icons-react';
import useIsMobile, { setViewMode } from '../hooks/useIsMobile';
import { tabbarCalc } from '../lib/tabbarMetrics';

export default function ViewModeToggle() {
  const isMobile = useIsMobile();
  useLocation();   // 라우트 변경(로그인→/home 등) 시 재렌더 → 아래 token 재평가(로그인 직후 플로팅 즉시 숨김)
  // 로그인 등 사이드바 없는 화면에서만 플로팅 노출(인앱은 사이드바 SidebarViewControls가 담당 — 플로팅이 본문 가림 피드백).
  let token = '';
  try { token = localStorage.getItem('token') || ''; } catch (e) { /* */ }
  if (token) return null;   // 로그인 상태(사이드바 있음)면 플로팅 숨김
  // 현재 보이는 모드의 '반대'로 전환(누르면 강제 override 설정 → 전 페이지 즉시 반영·localStorage 유지).
  const toDesktop = isMobile;
  const Icon = toDesktop ? IconDeviceDesktop : IconDeviceMobile;
  const label = toDesktop ? '웹 화면' : '모바일 화면';

  return (
    <button
      type="button"
      onClick={() => setViewMode(toDesktop ? 'desktop' : 'mobile')}
      title={`${label}으로 전환 (현재 ${isMobile ? '모바일' : '웹'} 화면)`}
      aria-label={`${label}으로 전환`}
      style={{
        position: 'fixed', left: '14px',
        bottom: isMobile ? tabbarCalc(4) : '16px',
        zIndex: 1200, display: 'flex', alignItems: 'center', gap: '6px',
        minHeight: '42px', maxWidth: 'calc(100vw - 28px)', padding: '9px 13px', borderRadius: '22px',
        background: '#fff', border: '1px solid #d1d5db', color: '#374151',
        boxShadow: '0 2px 10px rgba(0,0,0,.15)', cursor: 'pointer',
        fontSize: '12px', fontWeight: 700, lineHeight: 1, boxSizing: 'border-box', WebkitTapHighlightColor: 'transparent',
      }}
    >
      <Icon size={16} stroke={1.8} />
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</span>
    </button>
  );
}
